import { useEffect, useRef, useState } from "react";
import Style from "./Style";

import videoDot from "./../../assets/images/videoDot.webp";

const View = ({ attributes, className: advancedClassName, updateVideo, children, VideoBox }) => {
  const { uniqueId, align, className, videos } = attributes;
  const domRef = useRef();

  const [players, setPlayers] = useState(null);

  useEffect(() => {
    if (players) {
      window.players = players;
      players.forEach((item) => item.destroy());
    }
    setPlayers(
      Plyr.setup("#timelinePlayer", {
        clickToPlay: false,
      })
    );
  }, [videos.length]);

  return (
    <>
      <Style attributes={attributes} />
      <div id={uniqueId} className={`${align} ${className} ${advancedClassName}`}>
        <div className="timelineWrapper" ref={domRef}>
          {videos.map((video, index) => (
            <div className={`timeline video${index + 1} ${video.videoPosition === "right" ? "videoRight" : ""}`} key={`video${index}`}>
              <div className="videoBox">
                <div id="timelinePlayer">
                  <iframe
                    src={`${video.videoSource}?origin=${window.location.origin}&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1`}
                    allowfullscreen
                    allowtransparency
                    allow="autoplay"
                  ></iframe>
                  {video.videoThumb && <div class="plyr__poster" style={{ backgroundSize: "cover", backgroundImage: `url(${video.videoThumb})` }}></div>}
                </div>
              </div>
              <div className="videoDot">
                <div className="videoBorder"></div>
                <img src={videoDot} className="videoDot" alt="videoDot" />
              </div>
              <VideoBox index={index} updateVideo={updateVideo} heading={video.heading} content={video.content} />
              {children}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default View;
